var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-component"},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"option-item",class:{ select: index === _vm.selectIndex },on:{"click":function($event){_vm.selectIndex = index}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(option.text))]),_c('div',{staticClass:"icon"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }